/**
 * HM-113 — Reception messaging API wrapper.
 *
 * `/messaging/send` (cluster 5/6 backend, HAL messaging mock per ora,
 * WhatsApp Business in cluster 12). Best-effort: se `to` e' null, il
 * backend ritorna 202 skipped.
 *
 * Ref: tasks.md HM-113.
 */
import { api } from './client.js';

export type MessagingTemplateName =
  | 'booking_confirmation'
  | 'access_code_delivery'
  | 'pre_checkin_reminder'
  | 'checkout_thanks'
  | 'payment_failed';

export type SendTemplateInput = {
  bookingId: string;
  template: MessagingTemplateName;
  to?: string | null;
  variables?: Record<string, string>;
};

export type SendTemplateResponse = {
  id?: string;
  status?: 'sent' | 'queued' | 'skipped';
};

export async function sendMessagingTemplate(
  input: SendTemplateInput,
): Promise<SendTemplateResponse> {
  return api('/messaging/send', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
